import React, { useMemo, useState } from "react";
import Modal from "react-modal";
import "normalize.css";
import close from "../../assets/close.svg";
import stronglyAgree from "../../assets/strongly_agree.gif";
import agree from "../../assets/agree.gif";
import neutral from "../../assets/neutral.gif";
import sad from "../../assets/sad.gif";
import stronglySad from "../../assets/strongly_sad.gif";
import TenPointLikertSlider, {
  buildTenPointAnswerOptions,
} from "./TenPointLikertSlider";
import "./AnswerTenPointSlider.css";
import "./LanguageChangeModal.css";

const fivePointQuestions = [
  { image: stronglyAgree, question: "Strongly Agree" },
  { image: agree, question: "Agree" },
  { image: neutral, question: "Neither Agree nor Disagree" },
  { image: sad, question: "Disagree" },
  { image: stronglySad, question: "Strongly Disagree" },
];

const LanguageModal = ({ isOpen, closeModal, isInfo, likertScaleCount = 5 }) => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const isTenPointScale = Number(likertScaleCount) === 10;
  const tenPointPreviewAnswers = useMemo(() => buildTenPointAnswerOptions(), []);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
    closeModal();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const modalStyles = {
    content: {
      width: isTenPointScale ? "min(92vw, 420px)" : "50%",
      maxWidth: isTenPointScale ? "420px" : "520px",
      padding: "49px 52px",
      borderRadius: "16px",
      height: "fit-content",
      border: "1px solid #5D5FEF",
      inset: "auto",
    },
    overlay: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Language Modal"
      style={modalStyles}
    >
      {isInfo ? (
        <>
          <div className="flex justify-between">
            <div className="lg:text-base md:text-base mobile:text-sm xs:text-sm font-bold">
              Instructions:
            </div>
            <img
              onClick={() => closeModal()}
              className="cursor-pointer"
              src={close}
              alt="close-icon"
            />
          </div>

          <div className="h-0.5 my-6 bg-underlineColor w-auto"></div>
          <ol className="list-decimal font-medium lg:text-base md:text-base mobile:text-xs ">
            <li className="lg:mb-6 md:mb-6 mobile:mb-3">
              The conversation between us will remain confidential and no one
              ever will get to know about it.
            </li>
            <li className="lg:mb-6 md:mb-6 mobile:mb-3">
              {isTenPointScale
                ? "For your responses, the survey uses a 10-point scale (1 = lowest, 10 = highest). Move the slider to choose your rating."
                : "The questions that I am going to ask you will have 5 response options represented by 5 different emoji's."}
            </li>
          </ol>

          {isTenPointScale ? (
            <div className="language-modal-ten-point">
              <div className="language-modal-ten-point__slider-wrap">
                <TenPointLikertSlider
                  answer={tenPointPreviewAnswers}
                  previewOnly
                  initialAnswerCode="5"
                />
              </div>
            </div>
          ) : (
            <ol className="flex flex-col gap-8 list-none pl-0">
              {fivePointQuestions.map((questionObj, index) => (
                <li
                  className="flex items-center gap-2.5 font-medium lg:text-base md:text-base mobile:text-xs"
                  key={index}
                >
                  <img
                    className="lg:w-8 md:w-6 mobile:w-6"
                    src={questionObj?.image}
                    alt=""
                  />
                  <span>
                    <span>represents </span>
                    <span className="text-primaryColor">
                      "{questionObj.question}"
                    </span>
                  </span>
                </li>
              ))}
            </ol>
          )}
        </>
      ) : (
        <>
          {" "}
          <h2>Language Change</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="languageSelect">Select Language:</label>
            <select
              id="languageSelect"
              value={selectedLanguage}
              onChange={handleLanguageChange}
            >
              <option value="en">English</option>
              <option value="fr">French</option>
              <option value="es">Spanish</option>
            </select>
            <button type="submit">Change Language</button>
          </form>
          <button onClick={closeModal}>Cancel</button>
        </>
      )}
    </Modal>
  );
};

export default LanguageModal;
